import { render, staticRenderFns } from "./ComboboxTerritoriosStatus.vue?vue&type=template&id=921bc704"
import script from "./ComboboxTerritoriosStatus.vue?vue&type=script&lang=js"
export * from "./ComboboxTerritoriosStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports